import {
  DataStorage,
  assetIdToProductType,
  mapSkuToAssetId,
  threekitApi,
  fileUrl,
  authToken,
} from "../../imports";
import { saveNode } from "./playerCreators";
import {
  setCurrentNode,
  updateDimensions,
  updatePlayerState,
} from "../reducers/playerSlice";
import { getCurrentFile } from "./fileCreators";
import fixedImages from "../../assets/fixedImageData";
import {
  getPanelDimensions,
  imageSize,
  checkFileUploadStatus,
  updatedSize4k,
  calculateRecommendedSize,
} from "../../helpers/playerHelpers";
import { setLoading } from "../reducers/threekitSlice";
import { uploadImage } from "./fabricCreators";
import { default as triptychMetadata } from "../../../../config/triptychMetadata";

export function resizeImage() {
  return (dispatch, getState) => {
    const state = getState();
    const { canWidth, canHeight } = state.playerState.dimensions;
    const node = state.playerState.currentNode;
    const productType = getProductType(state);
    const isMultipleCanvas = checkMultipleCanvas(state);
    let { imageHeightOriginal: imageHeight, imageWidthOriginal: imageWidth } =
      state.playerState.finalObj;
    const newCanHeight = canHeight * 96;
    const newCanWidth = canWidth * 96;
    if (productType === "triptych") {
      dispatch(
        setCanvasImageForTriptych(
          newCanHeight,
          newCanWidth,
          imageHeight,
          imageWidth
        )
      );
    } else if (isMultipleCanvas) {
      dispatch(
        setCanvasImageMultipleCanvas(
          newCanHeight,
          newCanWidth,
          imageHeight,
          imageWidth,
          node
        )
      );
    } else {
      dispatch(
        setCanvasImage(newCanHeight, newCanWidth, imageHeight, imageWidth)
      );
    }
  };
}

export function updateBorder(border) {
  return (dispatch, getState) => {
    const state = getState();
    let {
      finalObj: { imageHeightOriginal, imageWidthOriginal },
      dimensions: { canHeight, canWidth },
    } = state.playerState;
    canHeight = canHeight * 96;
    canWidth = canWidth * 96;

    border = border.charAt(0);

    if (border == "1") {
      canHeight = canHeight - 192;
      canWidth = canWidth - 192;
    } else if (border == "0") {
      canHeight = canHeight - 96;
      canWidth = canWidth - 96;
    }

    dispatch(
      setCanvasImage(
        canHeight,
        canWidth,
        imageHeightOriginal,
        imageWidthOriginal
      )
    );
  };
}

export function uploadFile(fixedImage = null) {
  return async (dispatch, getState) => {
    const state = getState();
    const node = state.playerState.currentNode;
    const productType = getProductType(state);

    if (checkFabricBuilder(state)) {
      dispatch(uploadImage(node));
    } else {
      let imageAsset;
      dispatch(setLoadingIcon(node));
      switch (productType) {
        case "triptych":
          imageAsset = await dispatch(uploadTriptychImage(fixedImage));
          dispatch(changeImage(imageAsset.imageassetId));
          break;
        case "collage":
          imageAsset = await dispatch(
            uploadMultipleCanvasImage(node, fixedImage)
          );
          dispatch(changeImage(imageAsset.imageassetId, node));
          break;
        case "wall-display":
          imageAsset = await dispatch(
            uploadMultipleCanvasImage(node, fixedImage)
          );
          dispatch(changeImage(imageAsset.imageassetId, node));
          break;
        default:
          imageAsset = await dispatch(uploadSingleCanvasImage(fixedImage));
          dispatch(changeImage(imageAsset.imageassetId));
      }
      window.playerObj.api.camera.frameBoundingSphere();
      dispatch(setQuaternion(window.playerObj.api.camera.getQuaternion()));
      // this.rotateCanvas();
    }
    dispatch(setLoading(false));
  };
}

export function setUpThreekit() {
  return async (dispatch, getState) => {
    return new Promise(async (resolve) => {
      const state = getState();
      const { assetId, childAssetId, selectedProduct } = state.threekit;
      const productType = getProductType(state);
      const isMultipleCanvas = checkMultipleCanvas(state);

      const playerApi = await window.threekitPlayer({
        authToken: authToken(),
        el: document.getElementById("player-container"),
        assetId,
        showAR: true,
        showLoadingThumbnail: true,
        showConfigurator: false,
        locale: "EN",
        allowMobileVerticalOrbit: true,
      });
      window.playerApi = playerApi;
      window.configurator = await window.playerApi.getConfigurator();
      window.playerObj = window.playerApi.enableApi("player");
      if (["triptych", "collage", "wall-display"].includes(productType)) {
        window.configurator
          .setConfiguration({
            panelName: { assetId: childAssetId },
          })
          .then(() => {
            window.playerObj = window.playerApi.enableApi("player");
            if (isMultipleCanvas) {
              dispatch(addToolToScene());
            }
            resolve();
          });
      } else {
        let title = selectedProduct.title || "";
        let parts = title.split(" ");
        let height = parseFloat(parts[0]) * 96;
        let width = parseFloat(parts[2]) * 96;

        if (!isNaN(height) && !isNaN(width)) {
          window.configurator
            .setConfiguration({
              Frame_Width: width,
              Frame_Height: height,
            })
            .then(() => {
              window.playerObj.api.camera.frameBoundingSphere();
              resolve();
            });
        } else {
          resolve();
        }
      }
    });
  };
}

export function setQuaternion(quaternion) {
  const pointer = DataStorage.create(quaternion);
  return { type: "threekit/setQuaternion", payload: pointer };
}

export function changeProduct(product) {
  return (dispatch, getState) => {
    const payload = { selectedProduct: product };
    dispatch({ type: "threekit/updateThreekitState", payload });
  };
}

export function changeProductVariant(product) {
  return (dispatch, getState) => {
    const payload = { selectedProduct: product };
    dispatch({ type: "threekit/updateThreekitState", payload });
  };
}

export function getQuaternion(state) {
  return DataStorage.find(state.threekit.quaternion);
}

export function getProductType(state) {
  return assetIdToProductType(state.threekit.assetId);
}

export function checkMultipleCanvas(state) {
  return !![
    "collage",
    "wall-display",
    "tshirt",
    "tshirt-youth",
    "tshirt-womens",
    "tile",
    "crewneck",
    "crewneck-youth",
    "hoodie",
    "hoodie-youth",
    "coaster",
    "coaster-square",
    "ornament",
    "magnet",
    "photos",
  ].includes(getProductType(state));
}

export function checkUploadedFile(state) {
  if (checkMultipleCanvas(state)) {
    return !!(Object.keys(state.files.files).length > 0);
  } else {
    return !!state.files.file;
  }
}

export function checkFabricBuilder(state) {
  return state.threekit.builder == "fabric";
}

export function checkAllFilesUploaded(state) {
  if (checkMultipleCanvas(state)) {
    const {
      playerState: {
        finalObj: { nodes },
      },
      files: { files },
    } = state;
    const nodeCount = Object.keys(nodes).length;
    const filesNeeded = nodeCount === 0 ? 1 : nodeCount;
    return !!(Object.keys(files).length >= filesNeeded);
  } else {
    return checkUploadedFile(state);
  }
}

export function getConfigurator(node, state) {
  if (node) {
    return DataStorage.find(
      state.playerState.finalObj.nodes[node].configurator
    );
  } else {
    return window.configurator;
  }
}

export function testImage() {
  return (dispatch, getState) => {
    const node = getState().playerState.currentNode;
    dispatch({
      type: "file/saveFilePointer",
      payload: { filePointer: fixedImages.cage.objAsset.imageassetId, node },
    });
    dispatch(uploadFile(fixedImages.cage));
  };
}

export function setLoadingIcon(node) {
  return (dispatch, getState) => {
    const isMultipleCanvas = checkMultipleCanvas(getState());
    const productType = getProductType(getState());
    const { loading } = fixedImages;
    if (isMultipleCanvas) {
      dispatch(changeImage(loading.objAsset.imageassetId, node));
      let { imgHeight, imgWidth, canvasHeight, canvasWidth } =
        getPanelDimensions(loading.height, loading.width, node);
      dispatch(
        setCanvasImageMultipleCanvas(
          canvasHeight,
          canvasWidth,
          Math.round(imgHeight),
          Math.round(imgWidth),
          node,
          false
        )
      );
    } else if (productType === "triptych") {
      const assetId = getState().threekit.assetId;
      const { height: imgHeight, width: imgWidth } = loading;
      const {
        updatedCanvasHeight,
        updatedCanvasWidth,
        updatedImageHeight,
        updatedImageWidth,
      } = getTriptychSizing(assetId, imgWidth, imgHeight);
      dispatch(
        setCanvasImageForTriptych(
          updatedCanvasHeight,
          updatedCanvasWidth,
          Math.round(updatedImageHeight),
          Math.round(updatedImageWidth)
        )
      );
      dispatch(changeImage(loading.objAsset.imageassetId));
    } else {
      dispatch(changeImage(loading.objAsset.imageassetId));
      let configuration = window.configurator.getConfiguration();
      dispatch(
        setCanvasImage(
          configuration.Frame_Height,
          configuration.Frame_Width,
          loading.height,
          loading.width
        )
      );
    }
  };
}

function getMaterialConfigurator() {
  return async (dispatch, getState) => {
    const state = getState();
    const {
      threekit: { assetId, childAssetId },
      playerState: { currentNode },
    } = state;
    const productType = getProductType(state);
    if (productType === "collage") {
      const panelid = playerObj.configurator.appliedConfiguration["panelName"];
      window.assetInstance = await window.playerObj.getAssetInstance({
        id: panelid,
        plug: "Proxy",
        property: "asset",
      });
      window.configuratorobj = await window.playerObj.getConfiguratorInstance({
        from: window.playerObj.api.scene.findNode({
          from: window.assetInstance,
          name: "Root", // this is name of the Root object. In 3Kit always the start node name should be Root
        }),
        name: currentNode, //this is frame1,frame2
        plug: "Material",
        property: "reference",
      });
    } else {
      var MaterialID = window.selectNodeName.split("_");
      var MaterialName = "Wall Material " + MaterialID[1];
      window.configuratorobj = await window.playerApi.getConfigurator(
        MaterialName
      );
    }
    dispatch(
      saveNode({
        data: { configurator: window.configuratorobj },
        node: currentNode,
      })
    );
  };
}

function addToolToScene() {
  return (dispatch, getState) => {
    const productType = getProductType(getState());
    let key, panelPrefix, panelType;
    if (productType === "collage") {
      key = "CanvasPrintCollage";
      panelPrefix = "frame";
      panelType = "PolyMesh";
    } else {
      key = "CanvasPrint";
      panelPrefix = "Canvas_";
      panelType = "Null";
    }

    window.playerObj.api.tools.addTool(
      {
        key,
        label: "Select",
        active: true,
        enabled: true,
        handlers: {
          mousedown: (e) => {
            const isDoubleClick = window.doubleClick === 1;
            if (!isDoubleClick) {
              window.doubleClick = 1;
              setTimeout(() => (window.doubleClick = null), 400);
            }

            const hits = e.hitNodes;
            if (!hits.length) return;

            var id = hits.length - 1;
            // var selectMeshID;
            // var selectCanvasName;
            // var selectCanvasID;
            const hierarchy = [...hits[id].hierarchy];
            hierarchy.reverse();
            const panel = hierarchy.find(
              (el) => el.type === panelType && el.name.includes(panelPrefix)
            );
            if (panel) {
              if (isDoubleClick) {
                setTimeout(
                  () => document.getElementById("threekit-fileupload").click(),
                  500
                );
              }
              //when nothing is selected
              window.playerObj.api.selectionSet.clear(); // clear the selection
              window.configuratorobj = null; //remove the config Object
              window.selectNodeName = ""; //remove the Selected node
              window.playerObj.api.selectionSet.add(panel.nodeId);
              window.selectNodeName = panel.name;
              dispatch(setCurrentNode(selectNodeName));
              dispatch(
                saveNode({
                  data: { nodeId: panel.nodeId },
                  node: selectNodeName,
                })
              );
              //node.setStyle({ outlineColor: '#00ff00', outlineThinkness: 5, color: '#ff0000', opacity: 0.5 });
              dispatch(getMaterialConfigurator());
            }
          }, //end of mouse event
        }, //end of handelers
      } //end fo add tool
    );
  };
}

function changeImage(imageValue, node) {
  return (dispatch, getState) => {
    getConfigurator(node, getState()).setConfiguration({
      sourceImage: {
        assetId: imageValue,
      },
    });
  };
}

function setNodeDataFromMetadata() {
  return (dispatch, getState) => {
    if (!getState().playerState.finalObj.metadata) {
      const finalObj = { nodes: {} };
      const metadata = window.playerObj.getConfigurator("panelName").metadata;
      finalObj.metadata = metadata;
      Object.keys(metadata)
        .filter((key) => !key.includes("position"))
        .forEach((key) => {
          finalObj.nodes[key] = {
            ...finalObj.nodes[key],
            rawDimensions: metadata[key],
            ratio: 1,
          };
        });
      dispatch(updatePlayerState({ data: { finalObj } }));
    }
  };
}

function setCanvasImageForTriptych(cnH, cnW, imgH, imgW) {
  return (dispatch) => {
    window.configurator.setConfiguration({
      canvas_width_orig: cnW,
      canvas_height_orig: Math.round(cnH),
    });
    const newFinalObj = {};
    newFinalObj.imageWidthOriginal = cnW;
    newFinalObj.imageHeightOriginal = Math.round(cnH);
    const newImageMagickObj = {};
    newImageMagickObj.imageposVertical = cnH / 2;
    newImageMagickObj.imageposHorizontal = cnW / 2;
    newImageMagickObj.verticalPos = cnH / 2;
    newImageMagickObj.horizontalPos = cnW / 2;
    newImageMagickObj.imageHeight = imgH;
    newImageMagickObj.imageWidth = imgW;
    newImageMagickObj.verticalMov = 0;
    newImageMagickObj.horizontalMov = 0;
    dispatch(
      updatePlayerState({
        data: {
          imageMagickObj: newImageMagickObj,
          finalObj: newFinalObj,
        },
      })
    );
  };
}

function getTriptychSizing(assetId, imgWidth, imgHeight) {
  const newState = { finalObj: {}, imageMagickObj: {} };
  newState.finalObj.imageHeightOriginal = imgHeight;
  newState.finalObj.imageWidthOriginal = imgWidth;

  newState.finalObj.metadata = triptychMetadata[assetId];

  //Getting the size from Metadata and setting in imageMagic Object
  const dimension = newState.finalObj.metadata["_size"].split("_");
  const canvasHeight = dimension[0];
  const canvasWidth = dimension[1];
  const heightRatio = canvasHeight / imgHeight;
  const widthRatio = canvasWidth / imgWidth;

  if (heightRatio > widthRatio) {
    imgHeight = imgHeight * heightRatio;
    imgWidth = imgWidth * heightRatio;
  } else {
    imgHeight = imgHeight * widthRatio;
    imgWidth = imgWidth * widthRatio;
  }
  // storing Calculated values for final output
  newState.imageMagickObj.imageHeightCal = imgHeight;
  newState.imageMagickObj.imageWidthCal = imgWidth;
  newState.imageMagickObj.verticalMov = 0;
  newState.imageMagickObj.horizontalMov = 0;
  newState.imageMagickObj.border = "Blur";

  //
  let reduceRatio = updatedSize4k(); //Matching it to 4k size
  newState.finalObj.reduceRatio = reduceRatio;
  const updatedCanvasHeight = canvasHeight / reduceRatio;
  const updatedCanvasWidth = canvasWidth / reduceRatio;
  const updatedImageHeight = imgHeight / reduceRatio;
  const updatedImageWidth = imgWidth / reduceRatio;
  return {
    newState,
    updatedCanvasHeight,
    updatedCanvasWidth,
    updatedImageHeight,
    updatedImageWidth,
  };
}

function uploadTriptychImage(fixedImage) {
  return async (dispatch, getState) => {
    const state = getState();
    const {
      threekit: { assetId },
    } = state;
    const file = fixedImage || getCurrentFile(state);
    const u = fixedImage || (await imageSize(file));
    let imgHeight = u.height;
    let imgWidth = u.width;
    const {
      newState,
      updatedCanvasHeight,
      updatedCanvasWidth,
      updatedImageHeight,
      updatedImageWidth,
    } = getTriptychSizing(assetId, imgWidth, imgHeight);

    // if we already have an image, skip uploading it again
    if (!newState.imageMagickObj.fileID || reloadImage) {
      if (fixedImage) {
        newState.objAsset = fixedImage.objAsset;
      } else {
        const jobId = await threekitApi.uploadFileToThreeKit(file);
        newState.objAsset = await checkFileUploadStatus(jobId);
      }
      newState.imageMagickObj.fileID = fileUrl().concat(
        newState.objAsset.imagefileId,
        "/content/"
      );
    }
    //set the canvas and image properties
    if (newState.objAsset) {
      newState.finalObj.assetId = newState.objAsset.imageassetId;
    }
    dispatch(updatePlayerState({ data: newState }));
    dispatch(
      setCanvasImageForTriptych(
        updatedCanvasHeight,
        updatedCanvasWidth,
        Math.round(updatedImageHeight),
        Math.round(updatedImageWidth)
      )
    );

    return newState.objAsset.imageassetId
      ? newState.objAsset
      : state.playerState.objAsset;
  };
}

function setCanvasImageMultipleCanvas(
  cnH,
  cnW,
  imgH,
  imgW,
  node,
  setState = true
) {
  return (dispatch, getState) => {
    const configurator = getConfigurator(node, getState());
    configurator.setConfiguration({
      canvas_vertical_global: cnH / 2,
      canvas_horizontal_global: cnW / 2,
      canvas_width_orig: cnW,
      canvas_height_orig: cnH,
      image_height: imgH,
      image_width: imgW,
    });
    if (setState) {
      const newNodeData = {};
      newNodeData.verticalPos = cnH / 2;
      newNodeData.horizontalPos = cnW / 2;
      newNodeData.canvasHeight = cnH;
      newNodeData.canvasWidth = cnW;
      newNodeData.imageHeight = imgH;
      newNodeData.imageWidth = imgW;
      newNodeData.verticalMov = 0;
      newNodeData.horizontalMov = 0;
      newNodeData.rotate = 0;
      dispatch(saveNode({ data: newNodeData, node }));
    }
  };
}

function uploadMultipleCanvasImage(node, fixedImage) {
  return async (dispatch, getState) => {
    const file = getCurrentFile(getState());
    const u = fixedImage || (await imageSize(file));
    let initialImgHeight = u.height;
    let initialImgWidth = u.width;
    dispatch(setNodeDataFromMetadata());
    let { imgHeight, imgWidth, canvasHeight, canvasWidth } = getPanelDimensions(
      initialImgHeight,
      initialImgWidth,
      node
    );
    const newNodeData = {};
    newNodeData.ratio = 1;
    if (fixedImage) {
      newNodeData.objAsset = fixedImage.objAsset;
    } else {
      const jobId = await threekitApi.uploadFileToThreeKit(file);
      newNodeData.objAsset = await checkFileUploadStatus(jobId);
    }
    dispatch(
      setCanvasImageMultipleCanvas(
        canvasHeight,
        canvasWidth,
        Math.round(imgHeight),
        Math.round(imgWidth),
        node
      )
    );
    dispatch(
      saveNode({
        data: {
          fileID: fileUrl().concat(
            newNodeData.objAsset.imagefileId,
            "/content/"
          ),
        },
        node,
      })
    );
    return newNodeData.objAsset;
  };
}

function setCanvasImage(cnH, cnW, imgH, imgW, shouldUpdateState = true) {
  return (dispatch) => {
    if (cnH && cnW && imgH && imgW) {
      let heightRatio = cnH / imgH;
      let widthRatio = cnW / imgW;
      let ratio = heightRatio > widthRatio ? heightRatio : widthRatio;
      imgH = imgH * ratio;
      imgW = imgW * ratio;
      const reduceRatio = updatedSize4k();
      const updatedCanvasHeight = cnH / reduceRatio;
      const updatedCanvasWidth = cnW / reduceRatio;
      const updatedImageHeight = Math.round(imgH / reduceRatio);
      const updatedImageWidth = Math.round(imgW / reduceRatio);
      window.configurator
        .setConfiguration({
          canvas_width_orig: updatedCanvasWidth,
          canvas_height_orig: updatedCanvasHeight,
          Frame_Width: cnW,
          Frame_Height: cnH,
          canvas_horizontal_global: updatedCanvasWidth / 2,
          canvas_vertical_global: updatedCanvasHeight / 2,
          image_height: updatedImageHeight,
          image_width: updatedImageWidth,
        })
        .then(() => window.playerObj.api.camera.frameBoundingSphere());
      if (shouldUpdateState) {
        dispatch(
          updatePlayerState({
            data: {
              imageMagickObj: {
                verticalPos: updatedCanvasHeight / 2,
                horizontalPos: updatedCanvasWidth / 2,
                imageHeight: updatedImageHeight,
                imageWidth: updatedImageWidth,
                verticalMov: 0,
                horizontalMov: 0,
                canWidth: cnW,
                canHeight: cnH,
              },
              finalObj: {
                imageHeightOriginal: imgH,
                imageWidthOriginal: imgW,
                canHeight: cnH,
                canWidth: cnW,
                reduceRatio,
                sizeRatio: ratio,
                ratio: 1,
              },
            },
          })
        );
      }
    }
  };
}

function uploadSingleCanvasImage(preloadedImage = null) {
  return async (dispatch, getState) => {
    const file = getCurrentFile(getState());
    const u = preloadedImage || (await imageSize(file));
    let imgHeight = u.height;
    let imgWidth = u.width;
    let [tempHeight, tempWidth] = calculateRecommendedSize(imgWidth, imgHeight);
    let newState;
    newState = {
      finalObj: {},
      imageMagickObj: {
        source: "threekit",
        verticalMov: 0,
        horizontalMov: 0,
      },
    };
    if (!preloadedImage) {
      const jobId = await threekitApi.uploadFileToThreeKit(file);
      newState.objAsset = await checkFileUploadStatus(jobId);
    } else {
      newState.objAsset = preloadedImage.objAsset;
    }
    newState.imageMagickObj.fileID = fileUrl().concat(
      newState.objAsset.imagefileId,
      "/content/"
    );
    dispatch(updateDimensions({ canHeight: tempHeight, canWidth: tempWidth }));
    newState.finalObj.imageHeightOriginal = imgHeight;
    newState.finalObj.imageWidthOriginal = imgWidth;
    newState.finalObj.ratio = 1;
    const canvasHeight = tempHeight * 96;
    const canvasWidth = tempWidth * 96;

    //set the canvas and image properties
    dispatch(
      setCanvasImage(
        canvasHeight,
        canvasWidth,
        Math.round(imgHeight),
        Math.round(imgWidth)
      )
    );
    dispatch(updatePlayerState({ data: newState }));
    return preloadedImage?.objAsset || newState.objAsset;
  };
}
